/**
 * Styled Components - Created by cazarez on 10/04/18.
 */
import styled from 'styled-components'
import Search from 'antd/lib/input/Search'

export const Title = styled.div`
  @media (max-width: 768px) {
    font-size: 20px;
  }
  color: #625F5F;
  font-family: var(--font-barlow);
  font-size: 24px;
  font-weight: 900;
  line-height: 33px;
  text-transform: uppercase;
`

export const Container = styled.div`
  background-color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 48px;
  position: relative;
  font-family: Avenir;
  #header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 40px auto;
    padding-inline: 28px;
    width: 100%;
    max-width: 1300px;
  }
  #filters {
    display: flex;
    justify-content: flex-end;
    margin-top: 18px;
    margin-inline: 38px;
    @media (max-width: 698px) {
      flex-direction: column;
      margin-inline: 28px;
    }
  }
  #resource-cards {
    display: flex;
    margin-inline: 28px;
    > .resource-card {
      flex: 1 1 0;
      min-width: 0;
    }
    > .resource-card:first-child {
      margin-right: 16px;
    }
    > .resource-card[data-position='last'] {
      margin-right: 10px;
    }
    @media (max-width: 980px) {
      display: block;
      > .resource-card:first-child {
        margin-right: 0;
        margin-bottom: 16px;
      }
      > .resource-card[data-position='last'] {
        margin-right: 0;
      }
    }
  }
  #preview-submit {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
    cursor: pointer;
    background: #302628;
    span {
      padding: 12px 28px;
      color: #FFF;
      font-family: var(--font-barlow);
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
      text-transform: capitalize;
    }
    @media (max-width: 698px) {
      display: none;
    }
  }
  #controls {
    display: flex;
    align-items: center;
    @media (max-width: 698px) {
      width: 100%;
      margin-top: 16px;
      flex-direction: column;
      #sortOptions {
        width: 100%;
        align-self: stretch;
        margin-top: 12px;
        .ant-select-selection {
          width: 100%;
        }
      }
    }
  }
  #sortOptions {
    width: 162px;
    height: 42px;
    transition: all .25s;
    align-self: flex-end;
    & .ant-select-selection {
      border-radius: 0;
      height: 42px;
      border: 1px solid #adadad;
    }
    .ant-select-selection-selected-value {
      padding-inline: 6px;
      padding-top: 7px;
    }
    .ant-select-selection__rendered {
      line-height: 28px;
      font-size: 13px;
      margin-left: 12px;
      margin-right: 12px;
    }
    .ant-select-selection__placeholder {
      color: #a4a4a4;
    }
  }
  #listContainer {
    width: 100%;
    max-width: 1300px;
    display: flex;
    flex-flow: column;
    min-height: 50vh;
    transition: all .25s;
  }
  .ant-spin {
    height: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .ant-pagination {
    align-self: center;
  }
  #list {
    display: flex;
    flex-wrap: wrap;
    margin-top: 16px;
    margin-inline: 28px;
  }
  .card {
    display: flex;
    flex-flow: column;
    margin-right: 10px;
    font-family: Avenir;
    margin-bottom: 28px;
    max-width: 300px;
    width: 100%;
    min-width: 128px;
    position: relative;
    @media (max-width: 1024px) {
      max-width: 230px;
    }
    @media (max-width: 698px) {
      max-width: 152px;
      margin-right: 6px;
      margin-left: 8px;
    }
  }
  .thmbnl {
    width: 100%;
    @media (max-width: 698px) {
      max-width: 176px;
    }
  }
  .quickIcon {
    max-width: 17px;
    transition: all .25s;
    background: #f1f4f561;
    border-radius: 25px;
    position: absolute;
    left: 8px;
    top: 8px;
    &:hover {
      cursor: pointer;
      filter: brightness(1) drop-shadow(0px 0px 1px gray);
    }
  }
  .name {
    font-weight: bold;
    margin-block: 9px 4px;
    font-size: 16px;
  }
  .dscrptr, .name {
    margin-left: 4px;
  }
  .lnk {
    margin-top: 5px;
    color: cornflowerblue;
    font-weight: 500;
    white-space: nowrap;
    i {
      margin-right: 10px;
    }
  }
`

export const SearchInput = styled(Search)`
  width: 435px;
  margin-right: 12px;
  #srch {
    padding: 5px 16px !important;
    margin-right: 12px;
    border-radius: 0 !important;
    border-bottom: none;
    height: 42px;
    border: 1px solid #adadad;
    text-align: center;
    position: relative;
    text-align: left;
    &:focus {
      border-color: black !important;
    }
  }
  @media (max-width: 698px) {
    width: 100%;
    margin-right: 0;
    #srch {
      width: 100%;
      margin-right: 0;
    }
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/ProductTemplates/styledComponents.tsx